<template>
  <div class="message-push">
    <header-top></header-top>
    <div class="main">
      <div class="operation flex-between">
        <div class="left flex">
          <el-button type="primary" @click="pushMsg">推送消息</el-button>
          <span class="line"></span>
          <el-select
            v-model="dateValue"
            @change="selectDate"
            placeholder="请选择时间"
            class="handle-select time"
            :class="{ custom: dateValue == '自定义时间' }"
          >
            <el-option
              v-for="item in dateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <!-- 自定义时间 -->
          <el-date-picker
            v-if="!filterDateReadonly"
            @change="getWeixinMassTemps"
            class="filter-date"
            :readonly="filterDateReadonly"
            v-model="filterDate"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </div>
        <div class="right">
          <el-input
            :placeholder="searchTextMsg"
            v-model="searchValueMsg"
            class="input-with-select"
            clearable
          >
            <el-select
              v-model="searchMsg"
              slot="prepend"
              placeholder="楼盘名称"
              @change="filterSelectMsg"
            >
              <el-option
                v-for="item in searchMsgOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getWeixinMassTemps"
            ></el-button>
          </el-input>
        </div>
      </div>
      <div class="main-table">
        <el-table
          :data="messages"
          ref="estateTable"
          stripe
          style="width: 100%"
          @sort-change="changeSort"
        >
          <el-table-column
            label="消息标题"
            prop="title"
            width="200"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="楼盘名称"
            prop="estateName"
            width="200"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.estateName | nullValue }}
            </template>
          </el-table-column>
          <el-table-column
            label="发布人"
            prop="creatorName"
            width="200"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span
                >{{
                  scope.row.organizationUnit
                    ? scope.row.organizationUnit + "-"
                    : ""
                }}{{ scope.row.creatorName | nullValue }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="备注" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.more | nullValue }}</span>
            </template>
          </el-table-column>
          <el-table-column label="内容" width="100">
            <template slot-scope="scope">
              <span class="theme-color" @click="lookContent(scope.row)"
                >消息内容</span
              >
            </template>
          </el-table-column>
          <el-table-column
            label="发布时间"
            sortable
            prop="creationTime"
            width="200"
          >
          </el-table-column>
          <template slot="empty">
            <div class="loading-box" v-if="isLoading">
              <img
                src="@/assets/image/loading.png"
                alt="loading"
                class="loading-ico"
              />
              数据加载中...
            </div>
            <div class="empty-box" v-if="!isLoading && !messages.length">
              列表为空
            </div>
          </template>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageIndex"
          :page-sizes="[20, 50, 100]"
          :page-size="query.maxResultCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        ></el-pagination>
      </div>
    </div>
    <el-drawer
      :with-header="false"
      :visible.sync="isHistoryShow"
      direction="rtl"
    >
      <div class="drawer-title">
        {{historyTitle}}
        <span @click="isHistoryShow = false">
          <svg-icon icon-class="close-ico" />
        </span>
      </div>
      <div class="history-content" v-html="msgContent" v-if="msgContent"></div>
      <div class="history-content" v-else>暂无内容</div>
    </el-drawer>
    <el-dialog
      title="推送预约模板消息"
      :visible.sync="isPushShow"
      class="dialog-weixin dialog-auto"
    >
      <el-form
        ref="pushMsgForm"
        :model="pushMsgForm"
        label-position="left"
        label-width="6rem"
        :rules="pushMsgRules"
        class="dialog-weixin-form"
      >
        <el-form-item label="预约楼盘" prop="estateName">
          <el-select
            v-model="pushMsgForm.estateName"
            clearable
            placeholder="请选择预约楼盘"
            @focus="relateEstate"
            ref="relateEstate"
          >
          </el-select>
        </el-form-item>
        <el-form-item label="预约意向" prop="intention" class="auto-height">
          <el-input
            v-model="pushMsgForm.intention"
            clearable
            placeholder="请输入标题"
            maxlength="64"
          ></el-input>
          <div class="form-tip">
            仅支持中文、英文、数字、_、-，不超过64个字符
          </div>
        </el-form-item>
        <el-form-item label="楼盘地址" prop="address">
          <el-input
            v-model="pushMsgForm.address"
            clearable
            placeholder="请输入楼盘地址"
            maxlength="128"
          ></el-input>
        </el-form-item>
        <el-form-item label="预约时间" prop="appointmentTime">
          <el-date-picker
            v-model="pushMsgForm.appointmentTime"
            type="date"
            placeholder="选择预约时间"
            clearable
          >
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="推送所有区域">
          <el-radio-group v-model="pushMsgForm.isAllArea" size="small">
            <el-radio-button :label="true">推送</el-radio-button>
            <el-radio-button :label="false">不推送</el-radio-button>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="备注" class="auto-height">
          <el-input
            type="textarea"
            placeholder="请输入备注"
            v-model="pushMsgForm.more"
            maxlength="200"
            show-word-limit
            resize="none"
          >
          </el-input>
          <div class="form-tip">
            仅支持中文、英文、数字、_、-，不超过200个字符
          </div>
        </el-form-item>
        <el-form-item label="消息模板" class="auto-height">
          <el-image ref="tempImg" class="weixin-temp-img" :src="tempImg">
          </el-image>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isPushShow = false">取 消</el-button>
        <el-button type="primary" @click="submitPushMsg" :loading="isLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="选择楼盘"
      :before-close="estateClose"
      :visible.sync="isEstateShow"
      class="dialog-estate dialog-auto"
    >
      <div class="estate-main">
        <div class="filter-heade">
          <el-input
            :placeholder="searchText"
            v-model="searchValue"
            class="input-with-select"
            @keypress.native.enter="getEstates"
            clearable
          >
            <el-select
              v-model="search"
              slot="prepend"
              placeholder="楼盘名称"
              @change="filterSelect"
            >
              <el-option
                v-for="item in searchOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getEstates"
            ></el-button>
          </el-input>
        </div>
        <el-table
          :data="estates"
          border
          ref="tb"
          :header-cell-style="{ background: '#f7f7f7;' }"
          @selection-change="handleEstatesChange"
          @sort-change="changeEstatesSort"
        >
          <el-table-column
            type="selection"
            width="50"
            align="center"
          ></el-table-column>
          <el-table-column label="楼盘名称" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column label="销售状态">
            <template slot-scope="scope">
              {{ scope.row.saleStatus }}
            </template>
          </el-table-column>
          <el-table-column label="行政区/街道" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.district }}-{{ scope.row.street }}</span>
            </template>
          </el-table-column>
          <el-table-column label="项目负责人" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="scope.row.counselors.length">
                <span v-for="(item, index) in scope.row.counselors" :key="index"
                  >{{ item.userName }}
                </span>
              </div>
              <div v-else>—</div>
            </template>
          </el-table-column>
          <el-table-column
            label="均价(元/㎡)"
            sortable
            prop="minPrice"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.minPrice }} - {{ scope.row.maxPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="总价(万)"
            sortable
            prop="minTotalPrice"
          >
            <template slot-scope="scope">
              <span
                >{{ scope.row.minTotalPrice }} -
                {{ scope.row.maxTotalPrice }}</span
              >
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="loading-box" v-if="isLoading">
              <img
                src="@/assets/image/loading.png"
                alt="loading"
                class="loading-ico"
              />
              数据加载中...
            </div>
            <div class="empty-box" v-if="!isLoading && !estates.length">
              列表为空
            </div>
          </template>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="estatesSizeChange"
          @current-change="estatesCurrentChange"
          :current-page.sync="estatePageIndex"
          :page-sizes="[10, 20, 30]"
          :page-size="estateQuery.maxResultCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="estateTotalCount"
        ></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isEstateShow = false">取消</el-button>
        <el-button
          type="primary"
          @click="submitEstate"
          :disabled="!checkedEstate.id"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import { dateFormat } from "@/common/filters";
import { debounce } from "@/utils/debounce";
import { getEstates } from "@/http/api/estate";
import { deepCopy } from "@/utils/deepCopy";
import {
  getWeixinMassTemps,
  sendMassAppointmentEstateTemp,
} from "@/http/api/weixin";

export default {
  components: {
    headerTop,
  },
  data() {
    return {
      tempImg: require("@/assets/image/weixin-temp.png"),
      searchFilter: "",
      dateValue: "",
      docUrl: "",
      videoUrl: "",
      search: "全文搜索",
      searchValue: "",
      searchText: "请输入楼盘名称/地址/项目负责人",
      searchMsg: "全文搜索",
      searchValueMsg: "",
      searchTextMsg: "请输入楼盘名称/消息标题/发布人名称",
      msgContent: "",
      uploadDocText: "上传图片",
      uploadImgText: "上传图片",
      uploadVideoText: "上传视频",
      uploadAudioText: "上传音频",
      historyTitle:'',
      filterDateReadonly: true, //禁止选择日期范围
      isLoading: false,
      isPushShow: false,
      isEstateShow: false,
      isHistoryShow: false,
      pageIndex: 1,
      estatePageIndex: 1,
      totalCount: 0,
      estateTotalCount: 0,
      permissions: {},
      tenantId:'',
      query: {
        type: "",
        maxResultCount: 20,
        sorting: "",
      },
      estateQuery: {
        maxResultCount: 20,
        saleStatus: "",
        isPutWeb: true,
        isPutChannel: true,
      },
      pushMsgForm: {
        estateId: "",
        estateName: "",
        intention: "",
        address: "",
        more: "",
        appointmentTime: "",
      },
      docFile: {},
      videoFile: {},
      audioFile: {},
      audioFiles: {},
      checkedEstate: {},
      estateInfo: {},
      editor: {},
      pushMsgRules: {
        intention: [
          { required: true, message: "请输入预约意向", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入楼盘地址", trigger: "blur" },
        ],
        estateName: [
          { required: true, message: "请选择预约楼盘", trigger: "change" },
        ],
        appointmentTime: [
          { required: true, message: "请选择预约时间", trigger: "change" },
        ],
      },
      dateOptions: [
        {
          key: "全部时间",
          value: "全部时间",
        },
        {
          key: "自定义时间",
          value: "自定义时间",
        },
      ],
      searchOptions: [
        {
          value: "name",
          label: "楼盘名称",
        },
        {
          value: "realAddress",
          label: "楼盘地址",
        },
        {
          value: "userName",
          label: "项目负责人",
        },
        {
          value: "",
          label: "全文搜索",
        },
      ],
      searchMsgOptions: [
        {
          value: "estateName",
          label: "楼盘名称",
        },
        {
          value: "title",
          label: "消息标题",
        },
        {
          value: "creatorName",
          label: "发布人名称",
        },
        {
          value: "",
          label: "全文搜索",
        },
      ],
      filterDate: [], //选择日期范围
      messages: [],
      imgFiles: [],
      estates: [],
    };
  },
  methods: {
    // 查看模板消息内容
    lookContent(v) {
      this.isHistoryShow = true;
      this.historyTitle=v.title;
      this.msgContent = v.content;
    },
    // 打开发布消息接口
    pushMsg() {
      if (this.permissions["WeiXinPushMessage.PushMassTemplate"]) {
        this.isPushShow = true;
        this.$nextTick(() => {
          this.$refs["pushMsgForm"].resetFields();
          this.pushMsgForm = {
            estateId: "",
            estateName: "",
            intention: "",
            address: "",
            more: "",
            appointmentTime: ""
          };
        });
      } else {
        this.$message.warning({
          message: `您暂无微信推送消息权限`,
          showClose: true,
        });
      }
    },
    // 楼盘搜索前置条件
    filterSelect(val) {
      switch (val) {
        case "name":
          this.searchText = "请输入楼盘名称";
          break;
        case "realAddress":
          this.searchText = "请输入楼盘地址";
          break;
        case "userName":
          this.searchText = "请输入项目负责人";
          break;
        case "":
          this.searchText = "请输入楼盘名称/地址/项目负责人";
          break;
      }
      this.searchKey = val;
    },
    // 消息搜索前置条件
    filterSelectMsg(val) {
      switch (val) {
        case "estateName":
          this.searchTextMsg = "请输入楼盘名称";
          break;
        case "title":
          this.searchTextMsg = "请输入消息标题";
          break;
        case "creatorName":
          this.searchTextMsg = "请输入发布人名称";
          break;
        case "":
          this.searchTextMsg = "请输入楼盘名称/消息标题/发布人名称";
          break;
      }
      this.searchKeyMsg = val;
    },
    // 关联楼盘窗口关闭回调
    estateClose() {
      this.isEstateShow = false;
      this.estatePageIndex = 1;
      this.estateQuery.maxResultCount = 20;
      this.estateQuery.sorting = '';
      this.search = "全文搜索";
      this.searchValue = "";
      this.searchText = "请输入楼盘名称/地址/项目负责人";
    },
    submitEstate() {
      let data = this.checkedEstate;
      this.pushMsgForm.estateId = data.id;
      this.pushMsgForm.estateName = data.name;
      this.pushMsgForm.address =
        data.city +
        data.district +
        data.street +
        data.business +
        data.realAddress;
      this.estateClose();
    },
    // 关联楼盘
    relateEstate() {
      this.getEstates();
      this.isEstateShow = true;
      this.$refs.relateEstate.visible = false;
    },
    // 多选框回调
    handleEstatesChange(selection) {
      this.checkedEstate = selection.length?selection[0]:{};
      if (selection.length > 1) {
        this.$refs.tb.clearSelection();
        this.$refs.tb.toggleRowSelection(selection.pop());
      }
    },
    changeEstatesSort(val) {
      this.estateQuery.sorting =
        val.order == "descending"
          ? `${val.prop} desc`
          : val.order == "ascending"
          ? `${val.prop} asc`
          : "";
      this.getEstates();
    },
    //获取楼盘
    getEstates() {
      let query = {
        maxResultCount: this.estateQuery.maxResultCount,
        skipCount: (this.estatePageIndex - 1) * this.estateQuery.maxResultCount,
      };
      if (this.searchValue) {
        query.filter = this.searchValue;
        query.condition = this.searchKey;
      }
      if (this.estateQuery.sorting) {
        query.sorting = this.estateQuery.sorting;
      }
      getEstates(query).then((res) => {
        this.estates = res.result.items;
        this.estateTotalCount = res.result.totalCount;
        this.isLoading = false;
      });
    },
    // 提交发布
    submitPushMsg() {
      this.$refs["pushMsgForm"].validate((valid) => {
        if (valid) {
          let data = deepCopy(this.pushMsgForm);
          delete data.estateName;
          data.appointmentTime = dateFormat(data.appointmentTime);
          if (this.tenantId) {
            data.isAllArea=false;
          }else{
            data.isAllArea=true;
          }
          this.isLoading = true;
          sendMassAppointmentEstateTemp(data).then((res) => {
            if (res) {
              this.$message.success({ message: "提交成功", showClose: true });
            }
            this.getWeixinMassTemps();
            this.isLoading = false;
            this.isPushShow = false;
          });
        } else {
          return false;
        }
      });
    },
    // 更改的页面数量
    handleSizeChange(val) {
      this.query.maxResultCount = val;
      this.getWeixinMassTemps();
    },
    // 跳转的指定页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getWeixinMassTemps();
    },
    // 更改的页面数量
    estatesSizeChange(val) {
      this.estateQuery.maxResultCount = val;
      this.getEstates();
    },
    // 跳转的指定页
    estatesCurrentChange(val) {
      this.estatePageIndex = val;
      this.getEstates();
    },
    // 排序
    changeSort(val) {
      this.query.sorting =
        val.order == "descending"
          ? `${val.prop} desc`
          : val.order == "ascending"
          ? `${val.prop} asc`
          : "";
      this.getWeixinMassTemps();
    },
    // 选择日期
    selectDate(e) {
      this.filterDateReadonly = true;
      this.filterDate = [];
      if (e == "自定义时间") {
        this.filterDateReadonly = false;
      } else {
        this.getWeixinMassTemps();
      }
    },
    getWeixinMassTemps() {
      let query = {
        maxResultCount: this.query.maxResultCount,
        skipCount: (this.pageIndex - 1) * this.query.maxResultCount,
      };
      if (this.filterDate && this.filterDate.length) {
        query.timeCondition = "CreationTime";
        query.startTime = dateFormat(this.filterDate[0]);
        query.endTime = dateFormat(this.filterDate[1]);
      }
      if (this.query.type) {
        query.type = this.query.type;
      }
      if (this.query.sorting) {
        query.sorting = this.query.sorting;
      }else{
        query.sorting ='creationTime desc';
      }
      if (this.searchValueMsg) {
        query.filter = this.searchValueMsg;
        query.intention = this.searchKeyMsg;
      }
      this.messages = [];
      getWeixinMassTemps(query).then((res) => {
        this.messages = res.result.items;
        this.totalCount = res.result.totalCount;
      });
    },
  },
  mounted() {
    this.$watch(
      "searchValueMsg",
      debounce(() => {
        this.getWeixinMassTemps();
      }, 200)
    );
    this.$watch(
      "searchValue",
      debounce(() => {
        this.getEstates();
      }, 200)
    );
    this.getWeixinMassTemps();
    this.permissions = this.$store.getters.permissions;
    this.tenantId=this.$store.getters.user.tenantId;
  },
};
</script>

<style scoped lang='scss'>
@import "@/styles/mixin.scss";
.message-push {
  .header-top {
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }

  .main {
    margin: 20px;
    padding: 20px;
    border-radius: $--border-radius-base;
    background-color: #fff;
    .operation {
      .left {
        .type-select {
          margin-left: 10px;
          width: 100px;
        }

        .line {
          width: 1px;
          height: 23px;
          background: #ddd;
          margin-left: 10px;
        }

        .handle-select {
          margin-left: 10px;
          &.time {
            width: 115px;
          }
          &.custom {
            ::v-deep .el-input__inner {
              border-radius: 4px 0 0 4px;
            }
          }

          .el-input {
            &.is-focus {
              ::v-deep .el-input__inner {
                border-color: #ddd;
              }
            }
          }

          ::v-deep .el-input__inner:focus {
            border-color: #ddd;
          }
        }

        .filter-date {
          margin-left: -1px;
          z-index: 2;
          border-radius: 0px 4px 4px 0;
          &:hover {
            border-color: #ddd;
          }
          &.isactive {
            border-color: $--color-primary;
          }
        }
      }

      .right {
        .input-with-select {
          width: 410px;
          .el-select {
            width: 115px;
          }
        }
      }
    }

    .main-table {
      padding-top: 20px;

      .el-table {
        margin-bottom: 20px;
      }
    }
  }

  .dialog-weixin {
    .el-date-picker.el-input,
    .el-input,
    .el-select {
      width: 367px !important;

      ::v-deep .el-icon-date {
        left: 330px !important;
      }
    }

    .el-radio-group {
      ::v-deep .el-radio-button__inner {
        width: 73px;
      }
    }

    .weixin-form {
      margin-bottom: 40px;
    }

    .upload-btn {
      margin-right: 10px;
      border: 1px solid rgba(221, 221, 221, 1);
      width: 110px;
      height: 30px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
    }

    i {
      cursor: pointer;
      margin-right: 5px;

      &.el-icon-close {
        margin-right: 0;
      }
    }

    .weixin-items {
      .weixin-item {
        display: flex;
        align-items: flex-end;
        margin-bottom: 8px;
        line-height: 0;

        .weixin-img,
        .weixin-form-img {
          margin-right: 10px;
          width: 197px;
          height: 148px;
        }

        .weixin-form-video {
          margin-right: 10px;
          height: 148px;
        }

        .audio-flex {
          height: 148px;
          flex-direction: column;
          align-items: start;

          .audio-item {
            text-align: left;
            line-height: 1rem;
            max-width: 150px;
            white-space: nowrap; /*内容超宽后禁止换行显示*/
            overflow: hidden; /*超出部分隐藏*/
            text-overflow: ellipsis; /*文字超出部分以省略号显示*/

            &:first-child {
              padding-top: 5px;
              margin-bottom: 20px;
            }
          }
        }
      }
    }

    .weixin-temp-img {
      width: 367px;
      height: 295px;
    }
  }

  .dialog-estate {
    .estate-main {
      width: 1080px;
      .filter-heade {
        margin-bottom: 20px;
        .input-with-select {
          width: 410px;
          .el-select {
            width: 110px;
          }

          ::v-deep .el-input__inner {
            border-right: 0;
          }
        }
        .filter-btn {
          margin-top: 20px;
          .filter-tit {
            margin-right: 10px;
          }
        }
      }

      .el-table {
        margin-bottom: 20px;
        ::v-deep .el-table__header-wrapper {
          .el-table__header {
            .has-gutter {
              .el-checkbox {
                display: none;
              }
            }
          }
        }
      }
    }
  }

  .el-drawer {
    .history-content {
      width: 500px;
    }
  }
}
</style>